module.exports = __webpack_public_path__ + "static/media/take-off.a155df43.svg";